import {
	Directive,
	Input,
	Output,
	EventEmitter,
	ElementRef,
	HostListener,
} from "@angular/core";

@Directive({
    selector: "[clickOutside]",
    standalone: false
})
export class ClickOutsideDirective {
	constructor(private elementRef: ElementRef) {}

	@Output() clickOutside = new EventEmitter<MouseEvent>();

	@HostListener("document:click", ["$event", "$event.target"])
	public onClick(event: MouseEvent, targetElement: HTMLElement): void {
		if (!targetElement) {
			return;
		}
		const clickedInside =
			this.elementRef.nativeElement.contains(targetElement);
		if (!clickedInside) {
			this.clickOutside.emit(event);
		}
	}
}
